import React from "react";

import HashLoader from "react-spinners/HashLoader";

const Loader = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <HashLoader size={50} color="#1E1E1E" loading={true} />
        </div>
    );
};

export default Loader;
